export default {
  instances: (state) => state.instances,
  editingInstance: (state) => state.editingInstance,
  loading: (state) => state.loading,
  page: (state) => state.page,
  sortBy: (state) => state.sortBy,
  orderBy: (state) => state.orderBy,
  search: (state) => state.search,
};
